// extracted by mini-css-extract-plugin
module.exports = {"badge-category":"JobAttributes_badge-category__1acOr","attributes-row":"JobAttributes_attributes-row__329VE"};